import styled, { css, createGlobalStyle } from 'styled-components'
import { color, size } from '../../shared/utils/styles'
import { Menu, Input, Select } from 'antd'
import { Button } from '../../shared/components'
import { ReactComponent as FalafelMenu } from '../../assets/icons-falafel-menu.svg'
import { ReactComponent as CaretDown } from '../../assets/icon-caret-down.svg'
import { ReactComponent as CaretUp } from '../../assets/icon-caret-up.svg'

export const MessageContainer = styled.div`
  margin-top: 50px;
`
export const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 16px;
  color: white;
  flex-wrap: wrap;
  .switch-disabled {
    color: ${color.gray30};
  }
  #icons_search_clear {
    cursor: pointer;
  }
`
const rowCommonStyle = css`
  color: ${color.gray10};
  max-width: 1388px;
  width: 100%;
  padding: 8px 8px 8px 16px;
  display: flex;
  align-items: center;
`
export const HeaderRow = styled.div`
  ${rowCommonStyle};
  background: ${color.gray80} 0% 0% no-repeat padding-box;
  font-size: 14px;
  border-top: 1px solid ${color.gray70};
`
export const Row = styled.div`
  ${rowCommonStyle};
  background-color: ${color.gray85};
  min-height: 48px;
  margin-bottom: 2px;
  border-radius: 4px;
`
export const RowExpand = styled.div`
  padding-right: 25px;
  svg .a {
    fill: none !important;
  }
`

export const RowContent = styled.div`
  padding-right: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const OrgRowContent = styled(RowContent)`
  flex-basis: 33%;
`
export const OrgRowContentLarge = styled(RowContent)`
  flex-basis: 50%;
`

export const DropdownGlobalStyle = createGlobalStyle`
  .ant-dropdown-menu {
    width: 240px;
    background-color: ${color.gray90};
    border: 1px solid ${color.gray70};
    @media (max-width: ${size.small}) {
      width: 200px;
    }
  }
  .ant-dropdown-menu-item {
    color: ${color.gray15};
    padding: 15px 12px;
    &> a {
      color: ${color.gray15};
      &:hover {
        color: ${color.gray15};
      }
    }
    &:hover {
      background-color: ${color.gray80};
    }
  }
`
export const StyledDropdownMenu = styled(Menu)`
  .ant-dropdown-menu-item {
    position: relative;
  }
`
export const UserRowContentLastCell = styled(RowContent)`
  float: right;
  padding-right: 0px;
`
export const SearchCreateRow = styled.div`
  max-width: 1388px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  minimum-height: 100%;
`
export const CreateButton = styled(Button)`
  width: 150px;
  height: 40px;
`
export const CountHeading = styled.div`
  margin-bottom: 8px;
  margin-top: 15px;
`
export const PaginationPlacing = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1388px;
  width: 100%;
`
export const RefreshButton = styled(Button)`
  width: 60px;
  height: 40px;
  margin-left: 4px;
  padding-top: 7px;
`
export const SearchInput = styled(Input)`
  width: 265px;
  height: 33px;
`
export const MoreItem = styled(FalafelMenu)`
  cursor: pointer;
  vertical-align: middle;
`
export const ProfileDetails = styled.div`
  color: ${color.gray10};
`

export const SelectFilter = styled(Select)``

export const TypeSelector = styled(Select)`
  width: 265px;
`

export const StatusSelector = styled(Select)`
  width: 100px;
  .ant-select-arrow {
    top: 16px;
  }
  margin-right: 8px;
`

export const IconExpand = styled(CaretDown)`
  cursor: pointer;
  vertical-align: middle;
`

export const IconHide = styled(CaretUp)`
  cursor: pointer;
  vertical-align: middle;
`
export const UserDetails = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr;
  grid-template-rows: auto;

  grid-template-areas:
    'StatusHeader EnabledHeader CreatedHeader UpdatedHeader SubscriptionHeader'
    'Status User-Status Created Updated Subscriptions';

  max-width: 1388px;
  padding: 8px 8px 8px 16px;

  background-color: ${color.gray70};
  color: ${color.gray10};
`

const HeaderCol = styled.div`
  border-bottom: 1px solid ${color.gray60};
  font-size: 14px;
  padding-right: 16px;
`

export const StatusHeader = styled(HeaderCol)`
  grid-area: StatusHeader;
`

export const EnabledHeader = styled(HeaderCol)`
  grid-area: EnabledHeader;
`

export const CreatedHeader = styled(HeaderCol)`
  grid-area: CreatedHeader;
`

export const UpdatedHeader = styled(HeaderCol)`
  grid-area: UpdatedHeader;
`

export const SubscriptionHeader = styled(HeaderCol)`
  grid-area: SubscriptionHeader;
`

const Value = styled.div`
  padding: 16px 16px 16px 0;
`

export const Status = styled(Value)`
  grid-area: Status;
`

export const UserStatus = styled(Value)`
  grid-area: User-Status;
`

export const Created = styled(Value)`
  grid-area: Created;
`

export const Updated = styled(Value)`
  grid-area: Updated;
`

export const Subscriptions = styled(Value)`
  grid-area: Subscriptions;
`

const CenteredHeaderCol = styled(HeaderCol)`
  text-align: center;
  padding: 0 8px;
`

export const ResourcesHeader = styled(CenteredHeaderCol)`
  grid-area: ResourcesHeader;
`

export const MembersHeader = styled(CenteredHeaderCol)`
  grid-area: MembersHeader;
`
export const NumberValue = styled.div`
  font-size: 21.6px;
`

export const NumberValueHeader = styled.span`
  display: inline-block;
`

export const EditContainer = styled.div`
  cursor: pointer;
  svg .a {
    fill: ${color.blueTint20};
  }
`

export const CloseContainer = styled.div`
  cursor: pointer;
  svg .a {
    fill: ${color.blueTint20};
  }
  span {
    color: ${color.gray03};
  }
`
export const EditButton = styled.span`
  font-size: 14px;
  padding-left: 6px;
  padding-right: 0;
  text-transform: uppercase;
  color: ${color.blueBase};
`
